import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { NEUTRAL_200, NEUTRAL_500, NEUTRAL_600, OBSIDIAN } from 'visitor-ui-component-library/constants/WidgetColors';
import { ChatWidgetLocaleContextConsumer } from '../ChatWidgetLocaleContext';
import ConsentPrompt from '../ConsentPrompt';
import { PROMPT_RECOMMENDATIONS, QUICK_REPLIES } from '../constants/consentPromptUsages';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConsentPromptWrapper = styled.div.withConfig({
  displayName: "ConsentPromptsOutsideChat__ConsentPromptWrapper"
})(["background:", ";color:", ";width:", ";"], NEUTRAL_500, OBSIDIAN, ({
  usageType
}) => usageType === PROMPT_RECOMMENDATIONS ? '384px' : '100%');
const SpamProtectionEnabledMessage = styled.div.withConfig({
  displayName: "ConsentPromptsOutsideChat__SpamProtectionEnabledMessage"
})(["border:1px solid ", ";padding:0 12px;background:", ";font-size:12px;color:", ";"], NEUTRAL_600, NEUTRAL_200, OBSIDIAN);
const ConsentPromptsOutsideChat = ({
  renderCookieConsentPrompt = false,
  consentToCookies,
  showingGdprProcess = false,
  consentToProcessMessage,
  showGdprConsentToProcessButton = false,
  consentToProcess,
  closeConsentToProcess,
  isPortal53 = false,
  usageType = QUICK_REPLIES,
  spamProtectionEnabled
}) => {
  if (!renderCookieConsentPrompt && !showingGdprProcess && !spamProtectionEnabled) {
    return null;
  }
  if (renderCookieConsentPrompt) {
    return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
      children: locale => /*#__PURE__*/_jsx(ConsentPromptWrapper, {
        usageType: usageType,
        children: /*#__PURE__*/_jsx(ConsentPrompt, {
          showButton: true,
          message: I18n.text('conversations-visitor-experience-components.gdpr.consentToCookies.pageLoadCookieConsent', {
            locale
          }),
          onClick: consentToCookies,
          isPortal53: isPortal53,
          isOutsideChat: true
        })
      })
    });
  }
  if (showingGdprProcess) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ConsentPromptWrapper, {
        usageType: usageType,
        children: /*#__PURE__*/_jsx(ConsentPrompt, {
          showButton: showGdprConsentToProcessButton,
          message: consentToProcessMessage,
          onClick: consentToProcess,
          onClose: closeConsentToProcess,
          isPortal53: isPortal53,
          isOutsideChat: true
        })
      }), !showGdprConsentToProcessButton && spamProtectionEnabled && /*#__PURE__*/_jsx(SpamProtectionEnabledMessage, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-experience-components.spamProtectionEnabled"
        })
      })]
    });
  }
  if (spamProtectionEnabled) {
    return /*#__PURE__*/_jsx(SpamProtectionEnabledMessage, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-experience-components.spamProtectionEnabled"
      })
    });
  }
  return null;
};
ConsentPromptsOutsideChat.displayName = 'ConsentPromptsOutsideChat';
export default ConsentPromptsOutsideChat;